/*
 * @Description: 
 */
export function unique(arr) {
    return arr.filter(function (item, index, arr) {
        //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
        return arr.indexOf(item, 0) === index;
    });
}


export function formatText(text) {
    if (!text || text === "") {
        return ""
    }
    if (typeof text === 'string') {
        text = text.replace(/\u0007/g, ''); // 移除 \u0007
        text = text.replace(/\r/g, ''); // 移除 \r
        text = text.replace(/\n/g, ''); // 移除 \n
        text = text.replace(/\t/g, ''); // 移除 \t
        text = text.replace(' ', ''); // 移除空格
    }
    return text
}

export function getRandomNum() {
    let randomNum = ""
    let arr = [];
    // 在此处补全代码
    function produceNum() {
        randomNum = Math.floor((Math.random() * 10) + 1)
        if (arr.indexOf(randomNum) === -1) { //判断不存在就push
            arr.push(randomNum)
        } else {
            if (arr.length >= 10) {
                arr = []
            }
            produceNum() //存在了重新调用
        };
    }
    produceNum()
    console.log(randomNum)
    return randomNum * 4;
}

// 使用原生实现替代
export function debounce(func, wait) {
    let timeout
    return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(this, args), wait)
    }
}
